import React from 'react';

import { Container } from './styles';

const Table: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Table;
